// Saved accessorials are stored as a JSON string of accessorial IDs covering
// both the location type and the selectable accessorials. Parse it defensively.
export const parseAccessorialIds = (value?: string | null): number[] => {
	if (!value) {
		return [];
	}
	try {
		const parsed = JSON.parse(value) as unknown;
		return Array.isArray(parsed)
			? parsed.filter((id): id is number => typeof id === "number")
			: [];
	} catch {
		return [];
	}
};
